module.exports = __webpack_public_path__ + "img/Frame Circle Tablet.f71bc6b2.webp";